import Base from '../../base';

export default class Default extends Base {
  init() {
    this.bus.$on('scroll/top', (d) => {this.scrollToTop(d);});

    this.bus.$on('vue/loaded', (d) => this.lazyScroll(d));
    this.bus.$on('vue/loaded', (d) => this.touchClasses(d));

    this.bus.$on('lazy/update', (d) => this.updateLazyEls(d));

    this.bus.$on('update:overlay', (d) => this.setOverflow(d));
  }

  touchClasses() {
    var is_touch = 'ontouchend' in document ? true : false;
    var is_mouse = 'onmousedown' in document ? true : false;

    //We want touch if available, but if both are then use mouse
    var click_event = is_touch /*&& !is_mouse*/ ? 'touchend' : 'click';
    
    $('body').addClass(`touch-${click_event}`);
  }

  lazyScroll() {
    
    this.bus.$on('window/resize', () => {
      this.onResize();
    });

    this.bus.$on('window/layout', () => {
      this.onResize();
    });

    this.bus.$on('window/scroll', () => {
      this.onScroll();
    });
  }

  onResize() {
    this.updateLazyEls();
    this.onScroll();
  }

  onScroll() {
    var scroll_top    = this.s.window.scroll.top.current;
    var window_height = this.s.window.resize.height.current;
    
    _.each(this.s.app.lazy, (l) => {
      if(l.show == true) return;

      var is_shown = l.top < scroll_top + (window_height*0.8);

      if(is_shown) {
        l.show = true;

        $(l.el).addClass('lazyShow');
      }
    });
  }

  scrollToTop(d) {
    $("body").velocity("scroll", { offset: "0", mobileHA: false });
  }

  updateLazyEls() {
    this.$lazy_els = $('.lazy');
    this.s.app.lazy = _.map(this.$lazy_els, (el) => {
      return {
        el: el,
        top: $(el).offset().top,
        show: false
      }
    });
  }

  setOverflow(d) {
    console.log('overlayed')
  }
}